var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-label',{staticClass:"gfm gfm-label",attrs:{"data-reference-type":"label","data-original":_vm.labelMarkdown,"scoped":_vm.isScopedLabel,"background-color":_vm.data.color,"title":_vm.data.title,"target":_vm.labelUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }